var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWholesale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 7.50944C14.9998 7.0492 15.3729 6.67611 15.8332 6.67611H16.6665C17.587 6.67611 18.3332 7.4223 18.3332 8.34277V15.0094C18.3332 15.9299 17.587 16.6761 16.6665 16.6761H4.99984C4.07936 16.6761 3.33317 15.9299 3.33317 15.0094V12.5094C3.33317 12.0492 3.70627 11.6761 4.1665 11.6761C4.62674 11.6761 4.99984 12.0492 4.99984 12.5094V15.0094H16.6665V8.34277H15.8332C15.3729 8.34277 14.9998 7.96968 14.9998 7.50944Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 5.00944C1.6665 4.08897 2.4127 3.34277 3.33317 3.34277H14.9998C15.9203 3.34277 16.6665 4.08897 16.6665 5.00944V11.6761C16.6665 12.5966 15.9203 13.3428 14.9998 13.3428H3.33317C2.4127 13.3428 1.6665 12.5966 1.6665 11.6761V5.00944ZM14.9998 5.00944L3.33317 5.00944V11.6761H14.9998V5.00944Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1665 7.50944C8.70627 7.50944 8.33317 7.88254 8.33317 8.34277C8.33317 8.80301 8.70627 9.17611 9.1665 9.17611C9.62674 9.17611 9.99984 8.80301 9.99984 8.34277C9.99984 7.88254 9.62674 7.50944 9.1665 7.50944ZM6.6665 8.34277C6.6665 6.96206 7.78579 5.84277 9.1665 5.84277C10.5472 5.84277 11.6665 6.96206 11.6665 8.34277C11.6665 9.72348 10.5472 10.8428 9.1665 10.8428C7.78579 10.8428 6.6665 9.72348 6.6665 8.34277Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWholesale);
export default __webpack_public_path__ + "static/media/menuWholesale.ab04a03f652e8b0dca3309cb3a3ea5bf.svg";
export { ForwardRef as ReactComponent };